// Path: ./src/app/components/SelectMui/index.tsx
import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { styled as MuiStyled } from "@mui/material/styles";
import { Wrapper, Text } from "./styled";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const StyledTextField: any = MuiStyled(Select)({
  "& .MuiSelect-select": {
    borderRadius: 10,
    backgroundColor: "white",
    padding: 6,
  },
});

interface Props<T extends string | number> {
  title?: string;
  selectedValue?: T;
  wrapperStyle?: string;
  selectOptions?: {
    label: string;
    value: T;
  }[];
  FormControlStyle?: Object;
  borderColor?: {
    normal?: string;
    hover?: string;
    focused?: string;
  };
  StyledTextFieldStyle?: Object;
  onSelect?: (value: T) => void;
  dataTestId?: string;
}

export default function MultipleSelect<T extends string | number>({
  title,
  selectOptions,
  wrapperStyle,
  FormControlStyle,
  borderColor,
  StyledTextFieldStyle,
  onSelect,
  selectedValue,
  dataTestId,
}: Props<T>) {
  const [value, setValue] = React.useState<T | "">(selectedValue || "");

  React.useEffect(() => {
    if (selectedValue !== undefined && selectedValue !== null) {
      setValue(selectedValue);
    }
  }, [selectedValue]);

  const handleChange = (event: SelectChangeEvent<string | number>) => {
    const newValue = event.target.value as T;
    setValue(newValue);
    onSelect && onSelect(newValue);
  };

  return (
    <Wrapper wrapperStyle={wrapperStyle} data-testid="multipleselect-test-id">
      {title && <Text>{title}</Text>}
      <FormControl sx={{ m: 1, width: 150, ...FormControlStyle }}>
        <StyledTextField
          value={value}
          onChange={handleChange}
          MenuProps={MenuProps}
          data-testid={dataTestId}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: borderColor?.normal || "white",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: borderColor?.hover || "#fd954f",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: borderColor?.focused || "#fd954f",
            },
            ...StyledTextFieldStyle,
          }}
        >
          {selectOptions?.map((option, key) => (
            <MenuItem
              sx={{
                backgroundColor: "white",
                "& .Mui-selected": {
                  backgroundColor: "red",
                },
                "&:hover .Mui-selected": {
                  backgroundColor: "red",
                },
              }}
              key={key}
              value={option.value}
              data-testid={`${dataTestId}-option`}
            >
              {option.label}
            </MenuItem>
          ))}
        </StyledTextField>
      </FormControl>
    </Wrapper>
  );
}
